import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Space, message } from 'antd';

function PasswordHide({
  condition,
  text,
  setPasswordOpen,
  passwordOpen,
  conditionSet,
}) {
  if (!text || text === 'Нет данных' || text === '' || text === ' ')
    return 'Нет данных';

  return (
    <Space style={{ width: '120px', justifyContent: 'space-between' }}>
      {condition ? (
        <>
          {text}
          <EyeOutlined
            color="black"
            style={{ justifySelf: 'end' }}
            onClick={() => {
              setPasswordOpen({ ...passwordOpen, [conditionSet]: false });
            }}
          />
        </>
      ) : (
        <>
          {'*'.repeat(text.length)}
          <EyeInvisibleOutlined
            color="black"
            onClick={(event) => {
              event.preventDefault();
              navigator.clipboard.writeText(text);
              message.success('Пароль скопирован');

              setPasswordOpen({ ...passwordOpen, [conditionSet]: true });
            }}
          />
        </>
      )}
    </Space>
  );
}

export { PasswordHide };
